import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import RoomTypeList from './RoomTypeList';
import UnavailableRoomTypeList from './UnavailableRoomTypeList';
import ResultLoader from 'components/Loader/ResultLoader';
import LoaderSkeletonCard from './LoaderSkeletonCard';
import { getRoomTypesWithoutOffers } from 'store/property/propertySelectors';
import {
  getHasValidQuery,
  getIsLoading,
  getUnavailableRoomTypes,
  getSortedAvailableRoomTypes,
} from 'store/propertyAvailability/propertyAvailabilitySelectors';

//memoised to prevent unnecessary renders when ResultLoader state changes
const LoaderResults = React.memo(({ availableRoomTypes, hasQuery }) => {
  const unavailableRoomTypes = useSelector(getUnavailableRoomTypes);

  return (
    <Fragment>
      <RoomTypeList roomTypes={availableRoomTypes} hasQuery={hasQuery} showPhoneFilters />
      {unavailableRoomTypes.length > 0 && <UnavailableRoomTypeList roomTypes={unavailableRoomTypes} hasQuery={hasQuery} />}
    </Fragment>
  );
});

LoaderResults.displayName = 'LoaderResults';

LoaderResults.propTypes = {
  availableRoomTypes: PropTypes.array.isRequired,
  hasQuery: PropTypes.bool.isRequired,
};

const RoomTypes = React.memo(() => {
  const hasQuery = useSelector(getHasValidQuery);
  const isLoading = useSelector(getIsLoading);

  const availableRoomTypes = useSelector(getSortedAvailableRoomTypes);
  const roomTypesWithoutOffers = useSelector(getRoomTypesWithoutOffers);
  const skeletonLoaderSize = availableRoomTypes.length || 5;

  return (
    <Fragment>
      {hasQuery && (
        <ResultLoader isLoading={isLoading} skeletonResultCount={skeletonLoaderSize} skeletonCardComponent={LoaderSkeletonCard}>
          <LoaderResults availableRoomTypes={availableRoomTypes} hasQuery={hasQuery} />
        </ResultLoader>
      )}
      {!hasQuery && <RoomTypeList roomTypes={roomTypesWithoutOffers} hasQuery={hasQuery} />}
    </Fragment>
  );
});

RoomTypes.displayName = 'RoomTypes';

export default RoomTypes;
